import { useUnderlyingSearch } from 'hooks/underlyings/use-underlying-search';
import { useAppSelector } from 'hooks/useAppSelector';
import { getBatchProductSubType, getBatchProductType } from 'state/selectors';

export function useMultipleApplyBatchUnderlyingsSearch(tabId: string, underlyingFieldId: string | undefined) {
  const productSubtype = useAppSelector(s => getBatchProductSubType(s, tabId));
  const productType = useAppSelector(s => getBatchProductType(s, tabId));
  return useUnderlyingSearch({ isLoading: false, productSubtype, productType }, underlyingFieldId);
}
